// NuevaMultimedia.jsx
import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

function NuevaMultimedia(props) {
	const { grupo, guardar, setQueMostrar } = props

	const datosInicial = {
		descripcion: '',
		orden: '',
		files: []
	}

	const [datos, setDatos] = useState(datosInicial)

	const handleClose = () => {
		setQueMostrar('')
		setDatos(datosInicial)
	}

	const handleProcesar = (e) => {
		e.preventDefault()
		if (!datos.files.length) {
			return // Aquí podrías mostrar un mensaje de error
		}
		guardar(datos)
		handleClose()
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const updateArchivo = (files) => {
		if (files.length > 0) {
			const datosCopia = { ...datos }
			datosCopia.files = files
			setDatos(prev => datosCopia)
		} else {
			const datosCopia = { ...datos }
			datosCopia.files = []
			setDatos(prev => datosCopia)
		}
	}

	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text={`Nueva multimedia - ${grupo.nombre}`} />
			<Offcanvas.Body>
				<h1>Datos del archivo multimedia</h1>
				<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="multimedia-descripcion">
										<FormLabel>Descripción</FormLabel>
										<Form.Control
											value={datos.descripcion}
											type="text"
											onChange={(e) => handleChange(e.target.value, 'descripcion')}
											required
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="multimedia-orden">
										<FormLabel>Orden</FormLabel>
										<Form.Control
											value={datos.orden}
											type="number"
											onChange={(e) => handleChange(e.target.value, 'orden')}
											required
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<FileUpload
										updateFiles={updateArchivo}
										title="Seleccionar archivo"
										accept="image/*"
									/>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button
					variant="primary"
					onClick={handleProcesar}
					disabled={!datos.files.length}
				>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default NuevaMultimedia